import React from "react";
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import { customStyles } from "../../../../pages/customStyles";

function AddJobInfo(props) {
  return (
    <div className="row m-0 mb-4">
      <fieldset className="mt-3">
        <legend className="w-auto">
          Job Info {props.record.id > 1 ? "-" : ""}{" "}
          {props.record.id > 1 ? props.record.id : ""}
        </legend>
        <form className="row g-3">
          <div class="col-md-6">
            <label for="CourseName" class="form-label confirm_value ">
              Department
            </label>
            <Select
              className={`shadow-none input-font-size margin-left-zero`}
              id="department"
              name="department"
              value={
                props.record.department
                  ? {
                      value: props.record.department_id,
                      label: props.record.department,
                    }
                  : null
              }
              onChange={(option) =>
                props.handleChangeAjobs(
                  option,
                  props.record.id,
                  "department",
                  props.index
                )
              }
              options={props.department
                .filter((item) => item && item.label)
                .sort((a, b) => a.label.localeCompare(b.label))}
              isSearchable
              placeholder="Select an option"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              }
              styles={customStyles}
            />
            {props.jobError?.department && (
              <small className="error_message">
                {props.jobError.department}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label for="AAdmissionType" class={"form-label confirm_value "}>
              Designation
            </label>
            <Select
            // style={{marginTop:"10px"}}
              className={`shadow-none input-font-size margin-left-zero mt-2`}
              id="exp_designation"
              name="exp_designation"
              value={
                props.record.exp_designation
                  ? {
                      value: props.record.designation_id,
                      label: props.record.exp_designation,
                    }
                  : null
              }
              onChange={(option) =>
                props.handleChangeAjobs(
                  option,
                  props.record.id,
                  "exp_designation",
                  props.index
                )
              }
              options={props?.designation}
              isSearchable
              placeholder="Select an option"
              maxMenuHeight={200}
              filterOption={(option, searchText) =>
                option.label.toLowerCase().includes(searchText.toLowerCase())
              }
              styles={customStyles}
            />
            {props.jobError?.designation && (
              <small className="error_message">
                {props.jobError.designation}
              </small>
            )}
          </div>

          <div className="row mt-2">
            <div className="col-md-6 col-12 ms-auto ListBtn">
              <ul className="List-Button d-flex justify-content-end">
                {/* Show Delete if there's more than 1 item */}
                {props.length > 1 && (
                  <li className="ListBtnItems">
                    <Link
                      to="javascript:void(0)"
                      className="secondaryButton"
                      variant="secondary"
                      onClick={(e) =>
                        props.admission_status === 1
                          ? null
                          : props.DeleteAddJobinfo(
                              props.record.id,
                              props.record.department
                            )
                      }
                    >
                      {/* <span className="material-icons download_icon align-middle">
              remove_circle
            </span> */}
                      Delete JobInfo
                    </Link>
                  </li>
                )}

                {/* Show Add only in last index */}
                {props.index === props.length - 1 && (
                  <li className="ListBtnItems">
                    <Link
                      to="javascript:void(0)"
                      className={`primaryButton text-center ${
                        props.admission_status === 1 ? "disabled" : ""
                      }`}
                      variant="primary"
                      onClick={
                        props.admission_status === 1
                          ? null
                          : props.handleAddJobinfo
                      }
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {/* <span className="material-icons download_icon align-middle">
              add_circle
            </span> */}
                      Add More JobInfo
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </form>
      </fieldset>
    </div>
  );
}
export default AddJobInfo;
